import { Controller } from "@hotwired/stimulus";
import { redirectTo, redirectToNewTab } from "../utils/misc";

export default class extends Controller {
  redirectToNewTab(event) {
    redirectToNewTab(event.currentTarget.dataset.url);
  }

  redirectToUrl(event) {
    redirectTo(event.currentTarget.dataset.url);
  }
}
